// import React, { useState, useEffect, useContext } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FaShoppingCart, FaTrash, FaPlus, FaMinus, FaArrowLeft } from 'react-icons/fa';
// import { ref, onValue, update, remove } from "firebase/database";
// import { db } from '../firebase';
// import { AuthContext } from '../AuthContext';
// import Navbar from './Navbar';
// import Footer from './Footer'; // Import Footer component

// const CartPage = () => {
//   const navigate = useNavigate();
//   const [cartItems, setCartItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const { currentUser } = useContext(AuthContext) || {};
//   const user = currentUser || JSON.parse(localStorage.getItem('userData'));

//   // Load cart items from Firebase or localStorage
//   useEffect(() => {
//     const loadCart = async () => {
//       try {
//         if (user?.id) {
//           // Fetch from Firebase for logged-in users
//           const cartRef = ref(db, `Watch/customers/${user.id}/cart`);
//           const unsubscribe = onValue(cartRef, (snapshot) => {
//             const data = snapshot.val();
//             if (data) {
//               const items = Object.keys(data).map(key => ({
//                 firebaseKey: key,
//                 ...data[key]
//               }));
//               setCartItems(items);
//               localStorage.setItem('cart', JSON.stringify(items));
//             } else {
//               setCartItems([]);
//               localStorage.removeItem('cart');
//             }
//             setLoading(false);
//           });
//           return () => unsubscribe();
//         } else {
//           // Fallback to localStorage for guests
//           const items = JSON.parse(localStorage.getItem('cart')) || [];
//           setCartItems(items);
//           setLoading(false);
//         }
//       } catch (err) {
//         console.error('Error loading cart:', err);
//         setError('Failed to load cart. Please try again.');
//         setLoading(false);
//       }
//     };

//     loadCart();
//   }, [user?.id]);

//   // Update item quantity
//   const updateQuantity = async (firebaseKey, newQuantity) => {
//     try {
//       if (!user?.id) {
//         // Handle guest users in localStorage
//         const updatedCart = cartItems.map(item => 
//           item.firebaseKey === firebaseKey ? { ...item, quantity: newQuantity } : item
//         );
//         setCartItems(updatedCart);
//         localStorage.setItem('cart', JSON.stringify(updatedCart));
//         return;
//       }

//       const item = cartItems.find(item => item.firebaseKey === firebaseKey);
//       if (!item || newQuantity < 1 || newQuantity > (item.maxQuantity || 10)) return;

//       const itemRef = ref(db, `Watch/customers/${user.id}/cart/${firebaseKey}`);
//       await update(itemRef, { quantity: newQuantity });
//     } catch (err) {
//       console.error('Error updating quantity:', err);
//       setError('Failed to update quantity. Please try again.');
//     }
//   };

//   // Remove item from cart
//   const removeItem = async (firebaseKey) => {
//     try {
//       if (!user?.id) {
//         // Handle guest users in localStorage
//         const updatedCart = cartItems.filter(item => item.firebaseKey !== firebaseKey);
//         setCartItems(updatedCart);
//         localStorage.setItem('cart', JSON.stringify(updatedCart));
//         return;
//       }

//       const itemRef = ref(db, `Watch/customers/${user.id}/cart/${firebaseKey}`);
//       await remove(itemRef);
//     } catch (err) {
//       console.error('Error removing item:', err);
//       setError('Failed to remove item. Please try again.');
//     }
//   };

//   // Calculate total price
//   const calculateTotal = () => {
//     return cartItems.reduce((total, item) => {
//       const itemPrice = item.price * (1 - (item.discount || 0) / 100);
//       return total + (itemPrice * item.quantity);
//     }, 0).toFixed(2);
//   };

//   // Proceed to checkout
//   const handleCheckout = () => {
//     if (!user) {
//       navigate('/login', { state: { from: '/cart', mergeCart: true } });
//       return;
//     }
//     navigate('/checkout');
//   };

//   // Merge guest cart with user cart on login
//   const handleLogin = () => {
//     navigate('/login', { state: { from: '/cart', mergeCart: true } });
//   };

//   // Inline styles
//   const styles = {
//     container: {
//       minHeight: '100vh',
//       backgroundColor: '#f9fafb',
//       padding: '32px 16px'
//     },
//     header: {
//       display: 'flex',
//       alignItems: 'center',
//       marginBottom: '24px',
//       maxWidth: '1200px',
//       margin: '0 auto 24px'
//     },
//     backButton: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//       color: '#3b82f6',
//       cursor: 'pointer',
//       backgroundColor: 'transparent',
//       border: 'none',
//       fontSize: '16px',
//       marginRight: '16px'
//     },
//     title: {
//       fontSize: '24px',
//       fontWeight: 'bold',
//       color: '#1f2937',
//       margin: 0
//     },
//     cartContainer: {
//       maxWidth: '1200px',
//       margin: '0 auto',
//       backgroundColor: 'white',
//       borderRadius: '8px',
//       boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
//       overflow: 'hidden'
//     },
//     cartLayout: {
//       display: 'flex',
//       flexDirection: 'column'
//     },
//     errorMessage: {
//       color: '#dc2626',
//       backgroundColor: '#fee2e2',
//       padding: '12px',
//       borderRadius: '4px',
//       margin: '16px',
//       textAlign: 'center'
//     },
//     // ... (keep all other style objects from your original code)
//   };

//   if (loading) {
//     return (
//       <div style={styles.container}>
//         <div style={{ textAlign: 'center', padding: '48px 0' }}>
//           Loading cart...
//         </div>
//       </div>
//     );
//   }

//   // Show login prompt for guests with items in cart
//   if (!user && cartItems.length > 0) {
//     return (
      
//       <div style={styles.container}>
//         <div style={styles.header}>
//           <button onClick={() => navigate(-1)} style={styles.backButton}>
//             <FaArrowLeft /> Back
//           </button>
//           <h1 style={styles.title}>Your Shopping Cart</h1>
//         </div>
//         <div style={styles.cartContainer}>
//           <div style={{ 
//             padding: '32px',
//             textAlign: 'center'
//           }}>
//             <h3>Sign in to save your cart</h3>
//             <p style={{ margin: '16px 0' }}>
//               You have {cartItems.length} item{cartItems.length !== 1 ? 's' : ''} in your cart
//             </p>
//             <button
//               onClick={handleLogin}
//               style={{
//                 padding: '12px 24px',
//                 backgroundColor: '#3b82f6',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '6px',
//                 cursor: 'pointer',
//                 fontSize: '16px',
//                 fontWeight: '500',
//                 margin: '8px'
//               }}
//             >
//               Login to Continue
//             </button>
//             <button
//               onClick={() => navigate('/products')}
//               style={{
//                 padding: '12px 24px',
//                 backgroundColor: 'transparent',
//                 color: '#3b82f6',
//                 border: '1px solid #3b82f6',
//                 borderRadius: '6px',
//                 cursor: 'pointer',
//                 fontSize: '16px',
//                 fontWeight: '500',
//                 margin: '8px'
//               }}
//             >
//               Continue as Guest
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (cartItems.length === 0) {
//     return (
//       <div style={styles.container}>
//         <div style={styles.header}>
//           <button onClick={() => navigate(-1)} style={styles.backButton}>
//             <FaArrowLeft /> Back
//           </button>
//           <h1 style={styles.title}>Your Shopping Cart</h1>
//         </div>
//         <div style={{ 
//           ...styles.cartContainer,
//           textAlign: 'center',
//           padding: '48px 0'
//         }}>
//           <FaShoppingCart size={48} style={{ marginBottom: '16px', color: '#d1d5db' }} />
//           <h3>Your cart is empty</h3>
//           <p style={{ color: '#6b7280', marginBottom: '24px' }}>
//             Looks like you haven't added anything to your cart yet
//           </p>
//           <button
//             onClick={() => navigate('/products')}
//             style={{
//               padding: '12px 24px',
//               backgroundColor: '#3b82f6',
//               color: 'white',
//               border: 'none',
//               borderRadius: '6px',
//               cursor: 'pointer',
//               fontSize: '16px'
//             }}
//           >
//             Continue Shopping
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//     <Navbar />
//     <div style={styles.container}>
//       <div style={styles.header}>
//         <button onClick={() => navigate(-1)} style={styles.backButton}>
//           <FaArrowLeft /> Back
//         </button>
//         <h1 style={styles.title}>Your Shopping Cart</h1>
//       </div>

//       {error && (
//         <div style={styles.errorMessage}>
//           {error}
//           <button 
//             onClick={() => setError(null)} 
//             style={{ 
//               marginLeft: '8px',
//               background: 'none',
//               border: 'none',
//               color: '#b91c1c',
//               cursor: 'pointer'
//             }}
//           >
//             ×
//           </button>
//         </div>
//       )}

//       <div style={styles.cartContainer}>
//         <div style={styles.cartLayout}>
//           {/* Items Section */}
//           <div style={{ flex: 2, padding: '24px' }}>
//             {cartItems.map((item) => (
//               <div key={item.firebaseKey} style={{ 
//                 display: 'flex',
//                 borderBottom: '1px solid #e5e7eb',
//                 padding: '16px 0',
//                 gap: '16px'
//               }}>
//                 <img
//                   src={item.image || '/placeholder-product.jpg'}
//                   alt={item.name}
//                   style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '4px' }}
//                 />
//                 <div style={{ flex: 1 }}>
//                   <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1f2937', marginBottom: '4px' }}>
//                     {item.name}
//                   </h3>
//                   <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px' }}>
//                     {item.brand}
//                   </p>
//                   {(item.selectedColor || item.selectedSize) && (
//                     <p style={{ fontSize: '14px', color: '#4b5563', marginBottom: '8px' }}>
//                       {item.selectedColor && `${item.selectedColor}`}
//                       {item.selectedColor && item.selectedSize && ' • '}
//                       {item.selectedSize && `Size: ${item.selectedSize}`}
//                     </p>
//                   )}
//                   <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#1f2937', marginBottom: '8px' }}>
//                     {item.discount > 0 && (
//                       <>
//                         <span style={{ fontSize: '14px', color: '#9ca3af', textDecoration: 'line-through', marginRight: '8px' }}>
//                           ₹{(item.price * item.quantity).toFixed(2)}
//                         </span>
//                         <span style={{ fontSize: '12px', fontWeight: 'bold', backgroundColor: '#fee2e2', color: '#b91c1c', padding: '2px 6px', borderRadius: '4px' }}>
//                           {item.discount}% OFF
//                         </span>
//                       </>
//                     )}
//                     <div>
//                       ₹{(item.price * (1 - (item.discount || 0) / 100) * item.quantity).toFixed(2)}
//                     </div>
//                   </div>
//                   <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                     <button
//                       style={{ width: '28px', height: '28px', borderRadius: '4px', backgroundColor: '#e5e7eb', border: 'none', cursor: 'pointer', fontSize: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
//                       onClick={() => updateQuantity(item.firebaseKey, item.quantity - 1)}
//                       disabled={item.quantity <= 1}
//                     >
//                       <FaMinus size={12} />
//                     </button>
//                     <input
//                       type="number"
//                       style={{ width: '40px', textAlign: 'center', padding: '4px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '14px' }}
//                       value={item.quantity}
//                       min="1"
//                       max={item.maxQuantity || 10}
//                       onChange={(e) => updateQuantity(item.firebaseKey, parseInt(e.target.value) || 1)}
//                     />
//                     <button
//                       style={{ width: '28px', height: '28px', borderRadius: '4px', backgroundColor: '#e5e7eb', border: 'none', cursor: 'pointer', fontSize: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
//                       onClick={() => updateQuantity(item.firebaseKey, item.quantity + 1)}
//                       disabled={item.quantity >= (item.maxQuantity || 10)}
//                     >
//                       <FaPlus size={12} />
//                     </button>
//                   </div>
//                   <button
//                     style={{ display: 'flex', alignItems: 'center', gap: '4px', backgroundColor: 'transparent', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: '14px', marginTop: '8px' }}
//                     onClick={() => removeItem(item.firebaseKey)}
//                   >
//                     <FaTrash size={14} /> Remove
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Order Summary Section */}
//           <div style={{ flex: 1, padding: '24px', backgroundColor: '#f9fafb' }}>
//             <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1f2937', marginBottom: '16px' }}>
//               Order Summary
//             </h2>
//             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
//               <span style={{ fontSize: '16px', color: '#4b5563' }}>Subtotal</span>
//               <span style={{ fontSize: '16px', fontWeight: '500', color: '#1f2937' }}>₹{calculateTotal()}</span>
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
//               <span style={{ fontSize: '16px', color: '#4b5563' }}>Shipping</span>
//               <span style={{ fontSize: '16px', fontWeight: '500', color: '#1f2937' }}>₹0.00</span>
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
//               <span style={{ fontSize: '16px', color: '#4b5563' }}>Tax</span>
//               <span style={{ fontSize: '16px', fontWeight: '500', color: '#1f2937' }}>Calculated at checkout</span>
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'space-between', margin: '24px 0', paddingTop: '16px', borderTop: '1px solid #e5e7eb' }}>
//               <span style={{ fontSize: '18px', fontWeight: 'bold', color: '#1f2937' }}>Total</span>
//               <span style={{ fontSize: '18px', fontWeight: 'bold', color: '#1f2937' }}>₹{calculateTotal()}</span>
//             </div>
//             <button
//               style={{ width: '100%', padding: '12px', backgroundColor: '#10b981', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '16px', fontWeight: '500' }}
//               onClick={handleCheckout}
//             >
//               Proceed to Checkout
//             </button>
//             <button
//               style={{ width: '100%', padding: '12px', backgroundColor: 'transparent', color: '#3b82f6', border: '1px solid #3b82f6', borderRadius: '6px', cursor: 'pointer', fontSize: '16px', fontWeight: '500', marginTop: '12px' }}
//               onClick={() => navigate('/products')}
//             >
//               Continue Shopping
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//     <Footer />
//     </>
//   );
// };

// export default CartPage;



import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaShoppingCart, FaTrash, FaPlus, FaMinus, FaArrowLeft } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import { ref, onValue, update, remove } from "firebase/database";
import { db } from '../firebase';
import { AuthContext } from '../AuthContext';
import Navbar from './Navbar';
import Footer from './Footer';

const CartPage = () => {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { currentUser } = useContext(AuthContext) || {};
  const user = currentUser || JSON.parse(localStorage.getItem('userData'));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Load cart items from Firebase or localStorage
  useEffect(() => {
    const loadCart = async () => {
      try {
        if (user?.id) {
          const cartRef = ref(db, `Watch/customers/${user.id}/cart`);
          const unsubscribe = onValue(cartRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
              const items = Object.keys(data).map(key => ({
                firebaseKey: key,
                ...data[key]
              }));
              setCartItems(items);
              localStorage.setItem('cart', JSON.stringify(items));
            } else {
              setCartItems([]);
              localStorage.removeItem('cart');
            }
            setLoading(false);
          });
          return () => unsubscribe();
        } else {
          const items = JSON.parse(localStorage.getItem('cart')) || [];
          setCartItems(items);
          setLoading(false);
        }
      } catch (err) {
        console.error('Error loading cart:', err);
        setError('Failed to load cart. Please try again.');
        setLoading(false);
      }
    };

    loadCart();
  }, [user?.id]);

  // Update item quantity
  const updateQuantity = async (firebaseKey, newQuantity) => {
    try {
      if (!user?.id) {
        const updatedCart = cartItems.map(item => 
          item.firebaseKey === firebaseKey ? { ...item, quantity: newQuantity } : item
        );
        setCartItems(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
        return;
      }

      const item = cartItems.find(item => item.firebaseKey === firebaseKey);
      if (!item || newQuantity < 1 || newQuantity > (item.maxQuantity || 10)) return;

      const itemRef = ref(db, `Watch/customers/${user.id}/cart/${firebaseKey}`);
      await update(itemRef, { quantity: newQuantity });
    } catch (err) {
      console.error('Error updating quantity:', err);
      setError('Failed to update quantity. Please try again.');
    }
  };

  // Remove item from cart
  const removeItem = async (firebaseKey) => {
    try {
      if (!user?.id) {
        const updatedCart = cartItems.filter(item => item.firebaseKey !== firebaseKey);
        setCartItems(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
        return;
      }

      const itemRef = ref(db, `Watch/customers/${user.id}/cart/${firebaseKey}`);
      await remove(itemRef);
    } catch (err) {
      console.error('Error removing item:', err);
      setError('Failed to remove item. Please try again.');
    }
  };

  // Calculate total price
  const calculateTotal = () => {
    return cartItems.reduce((total, item) => {
      const itemPrice = item.price * (1 - (item.discount || 0) / 100);
      return total + (itemPrice * item.quantity);
    }, 0).toFixed(2);
  };

  // Proceed to checkout
  const handleCheckout = () => {
    if (!user) {
      navigate('/login', { state: { from: '/cart', mergeCart: true } });
      return;
    }
    navigate('/checkout');
  };

  // Merge guest cart with user cart on login
  const handleLogin = () => {
    navigate('/login', { state: { from: '/cart', mergeCart: true } });
  };

  // Container styles
  const containerStyles = {
    minHeight: '100vh',
    backgroundColor: '#f9fafb',
    padding: '32px 16px',
    fontFamily: "'Inter', sans-serif"
  };

  // Header styles
  const headerStyles = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '32px',
    maxWidth: '1200px',
    margin: '0 auto 32px'
  };

  // Back button styles
  const backButtonStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#3b82f6',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
    fontSize: '16px',
    fontWeight: '500',
    marginRight: '16px',
    transition: 'color 0.2s ease'
  };

  // Title styles
  const titleStyles = {
    fontSize: '24px',
    fontWeight: '700',
    color: '#1f2937',
    margin: 0
  };

  // Loading spinner styles
  const spinnerStyles = {
    display: 'inline-block',
    width: '48px',
    height: '48px',
    border: '3px solid rgba(59, 130, 246, 0.3)',
    borderRadius: '50%',
    borderTopColor: '#3b82f6',
    animation: 'spin 1s ease-in-out infinite'
  };

  // Error message styles
  const errorMessageStyles = {
    backgroundColor: '#fee2e2',
    borderLeft: '4px solid #dc2626',
    color: '#b91c1c',
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '1200px',
    margin: '0 auto 24px'
  };

  // Empty cart container styles
  const emptyCartContainerStyles = {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    padding: '48px 24px',
    textAlign: 'center',
    maxWidth: '1200px',
    margin: '0 auto'
  };

  // Empty cart icon styles
  const emptyCartIconStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '64px',
    height: '64px',
    borderRadius: '50%',
    backgroundColor: '#e5e7eb',
    marginBottom: '16px'
  };

  // Button styles
  const primaryButtonStyles = {
    padding: '12px 24px',
    backgroundColor: '#3b82f6',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '500',
    transition: 'all 0.2s ease'
  };

  const secondaryButtonStyles = {
    ...primaryButtonStyles,
    backgroundColor: 'white',
    color: '#3b82f6',
    border: '1px solid #3b82f6'
  };

  // Cart container styles
  const cartContainerStyles = {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    gap: '24px',
    maxWidth: '1200px',
    margin: '0 auto'
  };

  // Items container styles
  const itemsContainerStyles = {
    flex: 1,
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    overflow: 'hidden'
  };

  // Order summary styles
  const orderSummaryStyles = {
    width: isMobile ? '100%' : '384px',
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    position: isMobile ? 'static' : 'sticky',
    top: '32px',
    alignSelf: 'flex-start'
  };

  // Cart item styles
  const cartItemStyles = {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    padding: '24px',
    borderBottom: '1px solid #e5e7eb',
    gap: '16px'
  };

  // Item image styles
  const itemImageStyles = {
    width: isMobile ? '100%' : '120px',
    height: isMobile ? '200px' : '120px',
    objectFit: 'cover',
    borderRadius: '8px'
  };

  // Quantity control styles
  const quantityControlStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    margin: '16px 0'
  };

  // Quantity button styles
  const quantityButtonStyles = {
    width: '32px',
    height: '32px',
    borderRadius: '6px',
    backgroundColor: '#f3f4f6',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s ease'
  };

  // Quantity input styles
  const quantityInputStyles = {
    width: '48px',
    textAlign: 'center',
    padding: '4px',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    fontSize: '16px'
  };

  // Discount badge styles
  const discountBadgeStyles = {
    fontSize: '12px',
    fontWeight: 'bold',
    backgroundColor: '#fee2e2',
    color: '#b91c1c',
    padding: '2px 8px',
    borderRadius: '9999px',
    marginLeft: '8px'
  };

  if (loading) {
    return (
      <div style={containerStyles}>
        <div style={{ textAlign: 'center', padding: '80px 0' }}>
          <div style={spinnerStyles}></div>
          <p style={{ marginTop: '16px', color: '#6b7280' }}>Loading your cart...</p>
        </div>
      </div>
    );
  }

  if (!user && cartItems.length > 0) {
    return (
      <div style={containerStyles}>
        <div style={headerStyles}>
          <button 
            onClick={() => navigate(-1)} 
            style={backButtonStyles}
            onMouseEnter={(e) => e.target.style.color = '#2563eb'}
            onMouseLeave={(e) => e.target.style.color = '#3b82f6'}
          >
            <FaArrowLeft /> Back
          </button>
          <h1 style={titleStyles}>Your Shopping Cart</h1>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
          style={emptyCartContainerStyles}
        >
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            backgroundColor: '#dbeafe',
            margin: '0 auto 16px'
          }}>
            <FaShoppingCart style={{ color: '#3b82f6', fontSize: '24px' }} />
          </div>
          <h3 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '8px' }}>Sign in to save your cart</h3>
          <p style={{ color: '#6b7280', marginBottom: '24px' }}>
            You have {cartItems.length} item{cartItems.length !== 1 ? 's' : ''} in your cart
          </p>
          <div style={{ 
            display: 'flex', 
            flexDirection: isMobile ? 'column' : 'row',
            gap: '12px',
            justifyContent: 'center'
          }}>
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              onClick={handleLogin}
              style={{
                ...primaryButtonStyles,
                backgroundColor: '#3b82f6',
                minWidth: '200px'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
            >
              Login to Continue
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => navigate('/products')}
              style={{
                ...secondaryButtonStyles,
                minWidth: '200px'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f4ff'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
            >
              Continue as Guest
            </motion.button>
          </div>
        </motion.div>
      </div>
    );
  }

  if (cartItems.length === 0) {
    return (
      <div style={containerStyles}>
        <div style={headerStyles}>
          <button 
            onClick={() => navigate(-1)} 
            style={backButtonStyles}
            onMouseEnter={(e) => e.target.style.color = '#2563eb'}
            onMouseLeave={(e) => e.target.style.color = '#3b82f6'}
          >
            <FaArrowLeft /> Back
          </button>
          <h1 style={titleStyles}>Your Shopping Cart</h1>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
          style={emptyCartContainerStyles}
        >
          <div style={emptyCartIconStyles}>
            <FaShoppingCart style={{ color: '#9ca3af', fontSize: '28px' }} />
          </div>
          <h3 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '8px' }}>Your cart is empty</h3>
          <p style={{ color: '#6b7280', marginBottom: '24px' }}>
            Looks like you haven't added anything to your cart yet
          </p>
          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => navigate('/products')}
            style={{
              ...primaryButtonStyles,
              backgroundColor: '#3b82f6',
              minWidth: '200px'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
          >
            Continue Shopping
          </motion.button>
        </motion.div>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <div style={containerStyles}>
        <div style={headerStyles}>
          <button 
            onClick={() => navigate(-1)} 
            style={backButtonStyles}
            onMouseEnter={(e) => e.target.style.color = '#2563eb'}
            onMouseLeave={(e) => e.target.style.color = '#3b82f6'}
          >
            <FaArrowLeft /> Back
          </button>
          <h1 style={titleStyles}>Your Shopping Cart</h1>
        </div>

        {error && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            style={errorMessageStyles}
          >
            <span>{error}</span>
            <button 
              onClick={() => setError(null)}
              style={{ 
                backgroundColor: 'transparent',
                border: 'none',
                color: '#b91c1c',
                fontSize: '20px',
                cursor: 'pointer'
              }}
            >
              &times;
            </button>
          </motion.div>
        )}

        <div style={cartContainerStyles}>
          {/* Items Section */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
            style={itemsContainerStyles}
          >
            <div style={{ padding: '24px' }}>
              <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '24px' }}>
                {cartItems.length} Item{cartItems.length !== 1 ? 's' : ''} in Cart
              </h2>
              
              <AnimatePresence>
                {cartItems.map((item) => (
                  <motion.div
                    key={item.firebaseKey}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.2 }}
                    layout
                    style={cartItemStyles}
                  >
                    <div style={{ flexShrink: 0 }}>
                      <img
                        src={item.image || '/placeholder-product.jpg'}
                        alt={item.name}
                        style={itemImageStyles}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '4px' }}>
                          {item.name}
                        </h3>
                        <button
                          onClick={() => removeItem(item.firebaseKey)}
                          style={{ 
                            color: '#9ca3af',
                            backgroundColor: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: '16px'
                          }}
                          onMouseEnter={(e) => e.target.color = '#ef4444'}
                          onMouseLeave={(e) => e.target.color = '#9ca3af'}
                        >
                          <FaTrash />
                        </button>
                      </div>
                      <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px' }}>
                        {item.brand}
                      </p>
                      {(item.selectedColor || item.selectedSize) && (
                        <p style={{ fontSize: '14px', color: '#4b5563', marginBottom: '12px' }}>
                          {item.selectedColor && `${item.selectedColor}`}
                          {item.selectedColor && item.selectedSize && ' • '}
                          {item.selectedSize && `Size: ${item.selectedSize}`}
                        </p>
                      )}
                      
                      <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: isMobile ? 'flex-start' : 'center', gap: '16px' }}>
                        <div style={quantityControlStyles}>
                          <button
                            style={quantityButtonStyles}
                            onClick={() => updateQuantity(item.firebaseKey, item.quantity - 1)}
                            disabled={item.quantity <= 1}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                          >
                            <FaMinus size={12} />
                          </button>
                          <input
                            type="number"
                            style={quantityInputStyles}
                            value={item.quantity}
                            min="1"
                            max={item.maxQuantity || 10}
                            onChange={(e) => updateQuantity(item.firebaseKey, parseInt(e.target.value) || 1)}
                          />
                          <button
                            style={quantityButtonStyles}
                            onClick={() => updateQuantity(item.firebaseKey, item.quantity + 1)}
                            disabled={item.quantity >= (item.maxQuantity || 10)}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                          >
                            <FaPlus size={12} />
                          </button>
                        </div>
                        
                        <div style={{ textAlign: isMobile ? 'left' : 'right' }}>
                          {item.discount > 0 && (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: isMobile ? 'flex-start' : 'flex-end', gap: '8px', marginBottom: '4px' }}>
                              <span style={{ fontSize: '14px', color: '#9ca3af', textDecoration: 'line-through' }}>
                                ₹{(item.price * item.quantity).toFixed(2)}
                              </span>
                              <span style={discountBadgeStyles}>
                                {item.discount}% OFF
                              </span>
                            </div>
                          )}
                          <div style={{ fontSize: '18px', fontWeight: '700', color: '#1f2937' }}>
                            ₹{(item.price * (1 - (item.discount || 0) / 100) * item.quantity).toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>
          </motion.div>

          {/* Order Summary Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            style={orderSummaryStyles}
          >
            <div style={{ padding: '24px' }}>
              <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '24px' }}>
                Order Summary
              </h2>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: '#6b7280' }}>Subtotal</span>
                  <span style={{ fontWeight: '500', color: '#1f2937' }}>₹{calculateTotal()}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: '#6b7280' }}>Shipping</span>
                  <span style={{ fontWeight: '500', color: '#1f2937' }}>Free</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: '#6b7280' }}>Tax</span>
                  <span style={{ fontWeight: '500', color: '#1f2937' }}>Calculated at checkout</span>
                </div>
                
                <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '16px', marginTop: '8px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: '18px', fontWeight: '700', color: '#1f2937' }}>Total</span>
                    <span style={{ fontSize: '18px', fontWeight: '700', color: '#1f2937' }}>₹{calculateTotal()}</span>
                  </div>
                </div>
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '24px' }}>
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={handleCheckout}
                  style={{
                    ...primaryButtonStyles,
                    backgroundColor: '#10b981',
                    width: '100%'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#059669'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#10b981'}
                >
                  Proceed to Checkout
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={() => navigate('/products')}
                  style={{
                    ...secondaryButtonStyles,
                    width: '100%'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f4ff'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                >
                  Continue Shopping
                </motion.button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CartPage;

